import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";


interface Props {
  onCloseModal: () => void;
}

export const SelectCsvInstitutionModal = ({ onCloseModal }: Props) => {
  const { setOpenHomeModal } = useModalContext();
  const { setCompanyCode } = useInstitutionsContext();

  return (
    <BasePageModal
      handleClose={onCloseModal}
      title="CSV用Web明細帳を作成"
      className="md-new-csv-select"
    >
      <h2>金融機関を選択</h2>
      <p>
        下記の対象金融機関のサイトから出力したCSVファイルをMoneyLinkに取り込むことができます。
      </p>
      <ul>
        <li>
          <button type="button" className="btn-bank" onClick={() => {
            setCompanyCode("33");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            PayPay銀行
          </button>
        </li>
        <li>
          <button type="button" className="btn-bank" onClick={() => {
            setCompanyCode("5221");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            京葉銀行（個人）
          </button>
        </li>
        <li>
          <button type="button" className="btn-bank" onClick={() => {
            setCompanyCode("5222");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            京葉銀行（法人）
          </button>
        </li>
        <li>
          <button type="button" className="btn-bank" onClick={() => {
            setCompanyCode("5432");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            名古屋銀行（法人）
          </button>
        </li>
        <li>
          <button type="button" className="btn-bank" onClick={() => {
            setCompanyCode("5621");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            みなと銀行（個人）
          </button>
        </li>
        <li>
          <button type="button" className="btn-bank" onClick={() => {
            setCompanyCode("5622");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            みなと銀行（法人）
          </button>
        </li>
        <li>
          <button type="button" className="btn-bank" onClick={() => {
            setCompanyCode("5651");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            島根銀行（個人）
          </button>
        </li>
        <li>
          <button type="button" className="btn-card" onClick={() => {
            setCompanyCode("9661");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            JCB法人カード
          </button>
        </li>
        <li>
          <button type="button" className="btn-card" onClick={() => {
            setCompanyCode("9664");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            MUFGカード・ビジネス/AMEX
          </button>
        </li>
        <li>
          <button type="button" className="btn-app" onClick={() => {
            setCompanyCode("9801");
            setOpenHomeModal("RegisterCsvAccount")
          }}>
            Times Pay
          </button>
        </li>
      </ul>
    </BasePageModal>
  );
};
